import { render } from "./SmsCode.vue?vue&type=template&id=708ad557&scoped=true"
import script from "./SmsCode.vue?vue&type=script&lang=js"
export * from "./SmsCode.vue?vue&type=script&lang=js"

import "./SmsCode.vue?vue&type=style&index=0&id=708ad557&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708ad557"]])

export default __exports__